// extracted by mini-css-extract-plugin
export default {"button-segment":"button-segment__YCFg"};